/* "No code?" (NoCodeHelp.tsx): a quiet trigger, and a small popup under it. */
.no-code {
  position: relative;
  display: inline-block;
}
.no-code__trigger {
  padding: 4px 2px;
  border: 0;
  background: none;
  color: var(--hire-link);
  font: inherit;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}
.no-code__trigger:focus-visible,
.no-code__close:focus-visible {
  outline: 3px solid var(--hire-focus);
  outline-offset: 2px;
  border-radius: var(--hire-radius-sm);
}
.no-code__panel {
  position: absolute;
  z-index: 20;
  top: calc(100% + 8px);
  left: 0;
  display: grid;
  gap: 8px;
  justify-items: start;
  width: min(320px, calc(100vw - 32px));
  padding: 16px;
  border: 1px solid var(--hire-line);
  border-radius: var(--hire-radius-md);
  background: var(--hire-surface);
  color: var(--hire-ink);
  animation: no-code-in var(--duration-base) var(--ease-out) both;
}
.no-code__panel[hidden] {
  display: none;
}
@keyframes no-code-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
}
.no-code__icon {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: var(--hire-radius-pill);
  background: var(--hire-warning-bg);
  color: var(--hire-warning);
}
.no-code__icon svg {
  width: 22px;
  height: 22px;
}
.no-code__title {
  margin: 0;
  font-size: 17px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.no-code__body {
  margin: 0;
  color: var(--hire-muted);
}
.no-code__close {
  position: absolute;
  top: 8px;
  right: 8px;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: var(--hire-radius-sm);
  background: none;
  color: var(--hire-muted);
  cursor: pointer;
}
.no-code__close svg {
  width: 18px;
  height: 18px;
}
